import { getUserListByRole } from 'api/user';
import { RoleName } from '@/assets/js/constants';

/**
 * 不同角色的用户列表
 */
const state = {
  allPmList: [],
  allBdList: [],
  allAmList: [],
  allPmListLoading: false,
  allBdListLoading: false,
  allAmListLoading: false,
};
const mutations = {
  SET_PM_LOADING(state, pmLoading) {
    state.allPmListLoading = pmLoading;
  },
  SET_PM_LIST(state, pmList) {
    state.allPmList = pmList;
  },
  SET_BD_LOADING(state, bdLoading) {
    state.allBdListLoading = bdLoading;
  },
  SET_BD_LIST(state, bdList) {
    state.allBdList = bdList;
  },
  SET_AM_LOADING(state, amLoading) {
    state.allAmListLoading = amLoading;
  },
  SET_AM_LIST(state, amList) {
    state.allAmList = amList;
  },
};
const actions = {
  getPmList({ commit, state }) {
    if (state['allPmListLoading'] === true || state['allPmList'].length > 0) {
      return;
    }
    commit('SET_PM_LOADING', true);
    getUserListByRole(RoleName.PM)
      .then((response) => {
        if (response.result) {
          let temp = [];
          temp = response.result.map((item) => ({
            label: item.uname,
            value: item.id,
          }));
          commit('SET_PM_LIST', temp);
        }
      })
      .finally(() => {
        commit('SET_PM_LOADING', false);
      });
  },
  getBdList({ commit, state }) {
    if (state['allBdListLoading'] === true || state['allBdList'].length > 0) {
      return;
    }
    commit('SET_BD_LOADING', true);
    getUserListByRole(RoleName.BD)
      .then((response) => {
        if (response.result) {
          let temp = [];
          temp = response.result.map((item) => ({
            label: item.uname,
            value: item.id,
          }));
          commit('SET_BD_LIST', temp);
        }
      })
      .finally(() => {
        commit('SET_BD_LOADING', false);
      });
  },
  getAmList({ commit, state }) {
    if (state['allAmListLoading'] === true || state['allAmList'].length > 0) {
      return;
    }
    commit('SET_AM_LOADING', true);
    getUserListByRole(RoleName.AM)
      .then((response) => {
        if (response.result) {
          let temp = [];
          temp = response.result.map((item) => ({
            label: item.uname,
            value: item.id,
          }));
          commit('SET_AM_LIST', temp);
        }
      })
      .finally(() => {
        commit('SET_AM_LOADING', false);
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
